(function($) {
  'use strict';
  var $tables = $('[data-limit-table-rows]');
  $tables.each(function(index) {
    var $table = $(this);
    var limit = parseInt($table.data('limitTableRows'), 10),
      id = $table.attr('id') || `table-limited-${index}`;

    var $rows = $table.find('tbody tr');
    if ($rows.length <= limit) {
      return;
    }
    var $rowsToHide = $rows.slice(limit || 3);
    $rowsToHide.hide();

    var $buttonWrapper = $(
      `<div class="offerings-table__btn-wrapper">
        <button class="offerings-table__btn" aria-controls="${id}" aria-expanded="false">
          Show more
        </button>
      </div>`
    ).insertAfter($table);
    var $button = $buttonWrapper.find('button');
    $button.on('click', function() {
      var expanded = $button.attr('aria-expanded');
      if (expanded === 'false') {
        $rowsToHide.show();
        $button.attr('aria-expanded', 'true');
        $button.text('Show less');
      } else {
        $rowsToHide.hide();
        $button.attr('aria-expanded', 'false');
        $button.text('Show more');
      }
    });
  });
})(jQuery);
